import { createSortOption } from "@nosto/preact"
export const sizes = [24, 48, 100, 200]
// export const sizes = [4, 8, 12, 14]

const isMobile = window.innerWidth < 1025;

export const sortOptions = [
    createSortOption("score", "Most Popular", { field: "score", order: "desc" }),
    createSortOption("rating", "Highest Rated", {field: "stats.ratingValue", order: "desc" }),
    // createSortOption("name", "Name: A to Z", { field: "name", order: "asc" }),
    // createSortOption("-name", "Name: Z to A", { field: "name", order: "desc" }),
    createSortOption("price", "Price Ascending", { field: "price", order: "asc" }),
    createSortOption("-price", "Price Descending", { field: "price", order: "desc" }),
    createSortOption("-date published", "Recently Added", { field: "datePublished", order: "desc" }),
]

export const defaultConfig = {
    sort: sortOptions[0],
    serpSize: sizes[0],
    autocompleteProductsSize: isMobile ? 2 : 6,
    autocompleteKeywordsSize: 10,
    historySize: 5
}

export const checkPageType = () =>{
    const body = document.querySelector("body");
    const pageType = body?.getAttribute("data-page-type")?.toLowerCase() || "";
    // console.log("get")
    const isBrandPage = pageType.includes("brand");
    
    if (isBrandPage) {
      nostojs(() => {
        Nosto.pageType("category")
        Nosto.pageType = () => {}
      })
    }

    // console.log(document.querySelector(".nosto_page_type"));
    // console.log(pageType, isBrandPage, 'from config');
    return isBrandPage;
}

// export const checkPageType = () => {
//     return new Promise((resolve) => {
//         const body = document.querySelector("body");
//         const pageType = body?.getAttribute("data-page-type")?.toLowerCase() || "";
//         const isBrandPage = pageType.includes("brand");

//         if (isBrandPage) {
//             nostojs(() => {
//                 Nosto.pageType("category");
//                 console.log(document.querySelector(".nosto_page_type"));
//                 console.log(pageType, isBrandPage, 'from config');
//                 setTimeout(() => {
//                     resolve(isBrandPage);
//                 }, 2000);
//             });
//         } else {
//             console.log(document.querySelector(".nosto_page_type"));
//             console.log(pageType, isBrandPage, 'from config');
//             resolve(isBrandPage);
//         }
//     });
// }